<!-- Blocked: criteria assigned to Contact Plans -->
<div mdbModal #deleteAiCriteriaModal="mdb-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="deleteAiCriteriaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-notify modal-warning" role="document">
    <div class="modal-content" *ngIf="target">
      <div class="modal-header">
        <p id="deleteAiCriteriaModalLabel" class="heading lead">Unable to Delete AI Criteria</p>
        <button type="button" class="close" aria-label="Close" (click)="deleteAiCriteriaModal.hide()">
          <span aria-hidden="true" class="white-text">×</span>
        </button>
      </div>
      <!--modal-header-->
      <div class="modal-body">
        <div class="text-center mb-3">
          <mdb-icon fas icon="exclamation-circle" size="4x" class="red-text animated rotateIn"></mdb-icon>
        </div>
        <div class="mb-3">
          The AI Criteria {{ isCode ? '' : 'Group' }} <span class="criteria-name">{{ target.name }}</span>
          cannot be deleted because {{ isCode ? 'it is' : 'its criteria codes are' }} assigned to the following Contact Plans:
        </div>
        <ul class="mb-3">
          <li *ngFor="let usage of usages">
            <ng-container *ngIf="!isCode"><span class="criteria-name">{{ usage.criteriaCode }}</span>: </ng-container>
            {{ usage.contactPlanTitle }} – {{ usage.triggerTitle }}
          </li>
        </ul>
        <div class="alert alert-warning small mb-3">
          Remove the criteria {{ isCode ? 'code' : 'codes' }} from these Contact Plan trigger steps before deleting.
        </div>
        <div class="modal-footer justify-content-center pb-0">
          <button type="button" mdbBtn color="primary" class="waves-light rounded text-white"
            (click)="deleteAiCriteriaModal.hide()" mdbWavesEffect>OK</button>
        </div>
      </div>
      <!--modal-body-->
    </div>
    <!--modal-content-->
  </div>
  <!--modal-dialog-->
</div>
<!--mdbModal-->

<!-- Not in use: type the exact code / group name to enable deletion -->
<app-confirm-delete-by-name-modal #confirmDeleteModal (deleted)="onConfirmedDelete()"></app-confirm-delete-by-name-modal>
